import { render, staticRenderFns } from "./EditPostBox.vue?vue&type=template&id=41ad8d63&"
import script from "./EditPostBox.vue?vue&type=script&lang=js&"
export * from "./EditPostBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports